import { useRef, useState } from "react";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Card, Grid } from "@mui/material";
import CenterForm from "./form";
import { SaveButton } from "layouts/common/buttons";

const AddCenter = (initialData, type) => {
  const [loading, setLoading] = useState(false);
  // Reference to the form
  const formRef = useRef();
  const handleSave = async () => {
    if (formRef.current) {
      setLoading(true);
      const isSubmitted = await formRef.current.submitHandler();
      setLoading(false);
      if (isSubmitted) {
        formRef.current.resetForm(); // Reset the form fields
      }
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <MDTypography variant="h6" color="white">
                Add Center
              </MDTypography>
              <SaveButton loading={loading} onClick={handleSave} />
            </MDBox>
            <CenterForm
              ref={formRef}
              initialData={{ name: "", email: "", address: "", city: "", country: "" }}
              type="create"
            />
          </Card>
        </Grid>
      </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default AddCenter;



